import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';

import {
    Button, TextField,
} from '@material-ui/core';

import * as ProgramStore from '../../../../app/store/ProgramStore';
import {
    datestamp, getLocalDate, pad2,
} from '../../../../youwell-common/dateUtils';
import { PortalModal } from '../../../../common/components';

const styles = theme => ({
    content: {
        padding: theme.spacing(2),
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',

        [theme.breakpoints.down('xs')]: {
            overflowY: 'initial',
        },
    },
    taskField: {
        marginBottom: theme.spacing(3),
    },
    actions: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const getTimeText = (date) => {
    const startTime = getLocalDate(date);
    return `${pad2(startTime.getHours())}:${pad2(startTime.getMinutes())}`;
};

class EditTask extends React.Component {
    state = {
        time: getTimeText(this.props.element.startTime),
        name: this.props.element.name,
        description: this.props.element.properties?.description || '',
    }

    closeDialog = () => {
        this.props.onClose();
    }

    handleChange = name => (event) => {
        this.setState({ [name]: event.target.value });
    }

    update = () => {
        const startTime = getLocalDate(this.props.element.startTime);
        startTime.setHours(this.state.time.slice(0, 2), this.state.time.slice(3, 5), 0, 0);

        const elementToUpdate = {
            ...this.props.element,
            displayName: this.state.name,
            properties: {
                description: this.state.description,
            },
            startTime,
        };

        this.props.updatePatientElement(elementToUpdate, {
            callback: this.closeDialog,
            reducerParams: { patientProgramId: this.props.currentProgram.id },
        });
    }

    delete = () => {
        this.props.deletePatientElement(this.props.element, {
            callback: this.closeDialog,
            reducerParams: { patientProgramId: this.props.currentProgram.id },
        });
    }

    render() {
        const {
            classes, translate, disabled, element,
        } = this.props;

        return (
            <PortalModal
                open={!!element}
                onClose={this.closeDialog}
                heading={`${translate(`time.weekdays.${getLocalDate(element.startTime)?.getDay()}`)} ${datestamp(element.startTime)}`}
            >
                <div className={classes.content}>
                    <TextField
                        label={translate('addTask.startAt')}
                        fullWidth
                        disabled={disabled}
                        type="time"
                        value={this.state.time}
                        onChange={this.handleChange('time')}
                        className={classes.taskField}
                    />

                    <TextField
                        label={translate('addTask.title')}
                        fullWidth
                        disabled={disabled}
                        value={this.state.name}
                        onChange={this.handleChange('name')}
                        className={classes.taskField}
                        error={this.state.validationError}
                    />

                    <TextField
                        label={translate('addTask.description')}
                        multiline
                        minRows={10}
                        fullWidth
                        disabled={disabled}
                        value={this.state.description}
                        onChange={this.handleChange('description')}
                        className={classes.taskField}
                    />
                </div>

                <div className={classes.actions}>
                    <Button variant="text" onClick={this.delete} size="small">
                        {translate('editTask.delete')}
                    </Button>
                    <Button variant="contained" color="primary" onClick={this.update} size="small">
                        {translate('editTask.update')}
                    </Button>
                </div>
            </PortalModal>
        );
    }
}

EditTask.propTypes = {
    translate: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    updatePatientElement: PropTypes.func.isRequired,
    deletePatientElement: PropTypes.func.isRequired,
    element: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    currentProgram: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
};

EditTask.defaultProps = {
    disabled: false,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    currentProgram: state.programStore.currentProgram,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(ProgramStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditTask));
